var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#CEA8BC",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M422.31-434.92 163.92-330.85q-16.3 6.16-30.11-3.33-13.81-9.49-13.81-26.5v-14.39q0-7.85 3.49-14.77 3.48-6.91 9.82-11.31l289-203.62v-177.54q0-23.8 16.94-40.74Q456.19-840 479.98-840q23.79 0 40.75 16.95 16.96 16.94 16.96 40.74v177.54l289 203.62q6.34 4.4 9.82 11.31 3.49 6.92 3.49 14.77v14.39q0 17.01-13.81 26.5-13.81 9.49-30.11 3.33L537.69-434.92v173.23l103 72.77q5.11 3.76 7.98 9.09t2.87 11.6v14q0 13.08-9.96 20.58-9.96 7.5-22.27 3.8L480-172.31l-139.31 42.46q-12.31 3.7-22.27-3.8-9.96-7.5-9.96-20.58v-14.23q0-5.92 2.87-11.3 2.87-5.37 7.98-9.16l103-72.77v-173.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.e14d98d0b7cf48b860d951461f66cde3.svg";
export { ForwardRef as ReactComponent };